export enum Language {
  EN = 'EN',
  RO = 'RO',
}
